import { useState } from 'react';

export default function PoolFAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'How much does it cost to build a pool in El Paso?',
      answer: 'Pool construction costs in El Paso range from $30,000-$100,000+ depending on size, type, and features. Basic fiberglass pools start around $30,000-$50,000, while custom gunite pools with features cost $50,000-$100,000+. Factors include pool size, depth, materials, decking, landscaping, and additional features like spas, waterfalls, or automation systems.'
    },
    {
      question: 'How long does it take to build a swimming pool?',
      answer: 'Fiberglass pools can be installed in 2-4 weeks, while gunite pools take 8-12 weeks from start to finish. Timeline includes design approval, permits (1-2 weeks), excavation (1-2 days), plumbing and steel (3-5 days), gunite application (1 day), tile and coping (1-2 weeks), and final finishes. Weather and permit delays can extend timelines.'
    },
    {
      question: 'What pool type is best for El Paso\'s climate?',
      answer: 'Gunite pools are ideal for El Paso\'s hot, dry climate due to their durability and ability to withstand temperature fluctuations. The plaster finish can be customized for heat reflection. Fiberglass pools also work well with their smooth, non-porous surface. Both types should include proper circulation, filtration, and shade features to combat intense sun exposure.'
    },
    {
      question: 'Do I need a permit to build a pool in El Paso?',
      answer: 'Yes, building permits are required for pool construction in El Paso. Your contractor should handle permit applications, which typically take 1-2 weeks for approval. Requirements include setback distances from property lines (usually 5-10 feet), safety barriers (fencing with self-closing gates), and electrical inspections. Permit costs range from $500-$2,000.'
    },
    {
      question: 'How much does pool maintenance cost in El Paso?',
      answer: 'Monthly pool maintenance in El Paso costs $80-$150 for professional service, or $30-$80 for DIY supplies. Annual costs include chemicals ($300-$600), electricity ($30-$50/month), water ($20-$40/month), and repairs ($200-$500). El Paso\'s dry climate means less algae growth but more evaporation, requiring frequent water additions and chemical balancing.'
    },
    {
      question: 'Can I use my pool year-round in El Paso?',
      answer: 'Yes, with a pool heater you can enjoy your pool 8-10 months per year in El Paso. Gas heaters cost $2,500-$5,000 and heat quickly but have higher operating costs. Heat pumps cost $3,000-$6,000 with lower operating costs but slower heating. Solar heating ($3,000-$7,000) is ideal for El Paso\'s abundant sunshine and has minimal operating costs.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-gray-600">
            Common questions about swimming pool construction in El Paso
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-200 hover:shadow-lg transition-shadow"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-8 py-6 text-left flex items-center justify-between gap-4 hover:bg-gray-50 transition-colors cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                  <i
                    className={`ri-arrow-${
                      openIndex === index ? 'up' : 'down'
                    }-s-line text-white text-xl`}
                  ></i>
                </div>
              </button>
              {openIndex === index && (
                <div className="px-8 pb-6">
                  <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
